import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  FormGroup,
  Label,
  Col,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
} from 'reactstrap';
import { SelectWrapper } from './styles';
import { getInputErrorsObject } from '../helper';

function SelectInput({
  name,
  labelName,
  options,
  register,
  errors,
  defaultValue,
  labelCol = '3',
  inputCol = '9',
  setValue = null,
  disabled = false,
  icon,
  className = '',
}) {
  const [selectValue, setSelectValue] = useState('');
  const [error, setError] = useState();

  useEffect(() => {
    if (name && errors) {
      setError(getInputErrorsObject(name, errors));
    }
  }, [name, errors && Object.keys(errors)]);

  useEffect(() => {
    if (setValue && defaultValue) {
      setSelectValue(defaultValue);
      setValue(name, defaultValue);
    }
  }, [defaultValue]);

  const handleChange = (value) => {
    setSelectValue(value);
    setValue(name, value);
  };

  return (
    <SelectWrapper>
      <FormGroup row>
        {labelName && (
          <Label md={labelCol} for={name} className="font-weight-bold">
            {labelName}
          </Label>
        )}
        <Col md={inputCol} className={className}>
          {icon ? (
            <InputGroup className="input-group-merge">
              <InputGroupAddon addonType="prepend">
                <InputGroupText className={disabled ? 'bg-disabled' : ''}>{icon}</InputGroupText>
              </InputGroupAddon>
              <Input
                type="select"
                name={name}
                {...register}
                value={selectValue}
                onChange={(e) => handleChange(e.target.value)}
                disabled={disabled}
              >
                {options.map((item) => {
                  return (
                    <option className="" key={item.value} value={item.value}>
                      {item.label}
                    </option>
                  );
                })}
              </Input>
            </InputGroup>
          ) : (
            <Input
              type="select"
              name={name}
              {...register}
              value={selectValue}
              onChange={(e) => handleChange(e.target.value)}
              disabled={disabled}
            >
              {options.map((item) => {
                return (
                  <option className="" key={item.value} value={item.value}>
                    {item.label}
                  </option>
                );
              })}
            </Input>
          )}
          {error && (
            <p className="text-danger tx-12 mb-0" style={{ paddingTop: '2px' }}>
              {error.message || 'Trường bắt buộc'}
            </p>
          )}
        </Col>
      </FormGroup>
    </SelectWrapper>
  );
}

SelectInput.propTypes = {
  register: PropTypes.object,
  name: PropTypes.string,
  labelName: PropTypes.string,
  labelCol: PropTypes.string,
  inputCol: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      name: PropTypes.string,
    }),
  ),
  defaultValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  setValue: PropTypes.func,
  errors: PropTypes.object,
  icon: PropTypes.object,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

export default SelectInput;
